import { render, staticRenderFns } from "./export-batch-button.vue?vue&type=template&id=0cbf5f35&"
import script from "./export-batch-button.vue?vue&type=script&lang=js&"
export * from "./export-batch-button.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports